import axios from "axios";

// Prefer same-origin so the app works on any preview URL / custom domain
// that ingresses `/api/*` to this backend. Falls back to the build-time
// REACT_APP_BACKEND_URL for non-browser contexts (SSR/tests).
const ORIGIN =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export const API = `${ORIGIN}/api`;

// Auth relies on httpOnly cookies set by the backend (access + refresh tokens).
// No tokens are ever stored in localStorage/sessionStorage (XSS-safe).
const api = axios.create({ baseURL: API, withCredentials: true });

// Endpoints that must never trigger a silent refresh-and-retry loop.
const NO_RETRY_PATHS = ["/auth/refresh", "/auth/login", "/auth/signup", "/auth/logout"];

let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const skip = !original || original._retry || NO_RETRY_PATHS.some((p) => original.url?.includes(p));
    if (status === 401 && !skip) {
      original._retry = true;
      try {
        // Share one in-flight refresh across concurrent 401s.
        refreshPromise = refreshPromise || api.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (refreshError) {
        refreshPromise = null;
        // Refresh failed — fall through and surface the original 401.
      }
    }
    return Promise.reject(error);
  }
);

export default api;
